import React from 'react';
import {CheckCircle} from 'lucide-react';
import './BroadbandRouter.css';

interface BroadbandPlanProps {
  selected: boolean;
  onSelect: () => void;
}

const BroadbandRouterBYO: React.FC<BroadbandPlanProps> = ({ selected, onSelect }) => {

  return (
      <div
          className={`w-full lg:min-h-[35rem] bg-white border border-gray-200 rounded-lg col-span-full group md:col-span-1 group hover:bg-fred-blue-600 hover:cursor-pointer ${selected ? 'active' : ''}`}
          onClick={() => onSelect()}>
        <div className="w-full px-4 py-2 sm:px-8 sm:py-4">
          <div className='flex justify-between items-center min-h-20'>
            <h5 className={`text-3xl font-semibold text-fred-purple-500 group-hover:text-white ${selected ? 'active' : ''}`}>No,
              BYO
              Router</h5>
            <CheckCircle className={`hidden w-12 h-12 group-hover:block group-hover:text-white ${selected ? 'active' : ''}`} />
          </div>
          <div className="flex flex-col justify-center items-center gap-4">
            <img className="w-1/2" src="images/wifi-router-byo.png" alt="Broadband router"/>
          </div>
          <div className={`description flex items-baseline my-4 ${selected ? 'active' : ''}`}>
            <p className="text-sm font-normal text-gray-500 group-hover:text-gray-100">Use our broadband connection with your own modem/router. To use your existing modem for FREDNET please check our settings on the FAQ page.</p>
          </div>
        </div>
      </div>
  );
};

export default BroadbandRouterBYO;
